import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { AdminService } from '../../../services/admin.service';
import { StepsControllerService } from '../../../services/steps-controller.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDelete } from '../../../modals/confirmDelete/confirmDelete.component';

@Component({
    selector: 'my-created-standards',
    templateUrl: './my-created-standards.component.html',
    styleUrls: ['./my-created-standards.component.css'],
})
export class MyCreatedStandards implements OnInit, OnDestroy {
    myList: any;
    errorMessage = false;

    constructor(
        private userService: UserService,
        private adminService: AdminService,
        public stepsControllerService: StepsControllerService,
        private modalService: NgbModal,
    ) { }

    ngOnInit() {
        this.getStandards();
    }
    ngOnDestroy() {

    }

    getStandards() {
        this.errorMessage = false;
        this.userService.getMyCreatedStandards().subscribe(
            (standResponse: any) => {
                if (standResponse.status === 200) {
                    this.myList = standResponse.body;
                }
            },
            (error) => {
                this.errorMessage = true;
            }
        );
    }
   
    standardDbClick(standardID) {
        let bigStandard = null;
        this.errorMessage = false;
        this.adminService.getStandard(standardID).subscribe(
            (res: any) => {
                if (res.status === 200) {
                    bigStandard = res.body;
                    this.stepsControllerService.setCurrentStandard(bigStandard);
                }
            },
            (error) => {
                this.errorMessage = true;
            }
        );
    }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/my-created-standards/my-created-standards.component.ts